// theme.ts
import { createTheme } from "@mui/material/styles";

const theme = createTheme({
  palette: {
    primary: {
      main: "#21a598",
      dark: "#1a8578",
    },
    secondary: {
      main: "#1e9e85",
      dark: "#167667",
      contrastText: "#fff",
    },
    text: {
      primary: "#000",
      secondary: "#555",
    },
    background: {
      default: "#f2f3f4",
      paper: "#fff",
    },
  },
  shape: {
    borderRadius: 6,
  },

  components: {
    MuiCssBaseline: {
      styleOverrides: {
        body: {
          backgroundColor: "#f2f3f4",
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          boxShadow: "none",
          "&:hover": { boxShadow: "none" },
        },
        containedPrimary: {
          backgroundColor: "#21a598",
          "&:hover": { backgroundColor: "#1a8578", boxShadow: "none" },
        },
        containedSecondary: {
          backgroundColor: "#000",
          color: "#fff",
          "&:hover": { backgroundColor: "#333", boxShadow: "none" },
        },
        outlinedPrimary: {
          borderColor: "#21a598",
          color: "#21a598",
          "&:hover": {
            backgroundColor: "rgba(33,165,152,0.08)",
            borderColor: "#1b887f",
            boxShadow: "none",
          },
        },
      },
    },
    MuiTextField: {
      styleOverrides: {
        root: {
          marginBottom: "16px",
          "& .MuiOutlinedInput-root": {
            minHeight: "40px",
            "&.Mui-focused fieldset": {
              borderColor: "#21a598",
              boxShadow: "none",
            },
            "&:hover fieldset": { borderColor: "#21a598", boxShadow: "none" },
          },
          "& .MuiInputLabel-root.Mui-focused": { color: "#21a598" },
        },
      },
    },
    MuiAutocomplete: {
      styleOverrides: {
        root: {
          "& .MuiOutlinedInput-root": { minHeight: "40px" },
        },
      },
    },
    MuiRadio: {
      styleOverrides: {
        root: {
          color: "#21a598",
          "&.Mui-checked": { color: "#21a598" },
        },
      },
    },
    MuiCheckbox: {
      styleOverrides: {
        root: {
          color: "#21a598",
          "&.Mui-checked": { color: "#21a598" },
        },
      },
    },
    MuiDivider: {
      variants: [
        {
          props: { variant: "special" }, // nombre de tu variante
          style: {
            backgroundColor: "#1e9e85", // verde
            height: "4px",
          },
        },
      ],
    },

    MuiPaper: {
      styleOverrides: {
        root: {
          boxShadow: "none",
        },
      },
    },
    MuiTableContainer: {
      styleOverrides: {
        root: {
          borderRadius: "8px",
          border: "1px solid #ddd",
          overflow: "hidden",
          boxShadow: "0px 4px 12px rgba(0, 0, 0, 0.15)", // sombra difusa
        },
      },
    },
    MuiTable: {
      styleOverrides: {
        root: {
          borderCollapse: "separate",
          borderSpacing: 0,
        },
      },
    },
    MuiTableHead: {
      styleOverrides: {
        root: {
          backgroundColor: "#000",
          "& .MuiTableCell-root": {
            color: "#fff",
            fontWeight: "bold",
            borderBottom: "1px solid #ddd",
          },
          "& .MuiTableRow-root:first-of-type .MuiTableCell-root:first-of-type": {
            borderTopLeftRadius: "8px",
          },
          "& .MuiTableRow-root:first-of-type .MuiTableCell-root:last-of-type": {
            borderTopRightRadius: "8px",
          },
        },
      },
    },
    MuiTableBody: {
      styleOverrides: {
        root: {
          "& .MuiTableRow-root:nth-of-type(odd)": {
            backgroundColor: "#fafafa",
          },
          "& .MuiTableRow-root:nth-of-type(even)": {
            backgroundColor: "#ffffff",
          },
          "& .MuiTableCell-root": {
            borderBottom: "1px solid #ddd",
          },
          "& .MuiTableRow-root:last-of-type .MuiTableCell-root:first-of-type": {
            borderBottomLeftRadius: "8px",
          },
          "& .MuiTableRow-root:last-of-type .MuiTableCell-root:last-of-type": {
            borderBottomRightRadius: "8px",
          },
        },
      },
    },
    MuiTableCell: {
      styleOverrides: {
        root: {
          borderBottom: "1px solid #ddd",
          padding: "8px 12px",
        },
      },
    },
    MuiTableRow: {
      styleOverrides: {
        root: {
          "&:hover": {
            backgroundColor: "inherit",
          },
          "&.MuiTableRow-hover:hover": {
            backgroundColor: "inherit",
          },
          "&.Mui-selected, &.Mui-selected:hover": {
            backgroundColor: "inherit",
          },
        },
      },
    },
  },
});

export default theme;
